import { API_URL } from "config";
import Http from "util/https";
import Notify from "config/notify";
import { OrderConfirmParams } from "../types";

/**
 * 注文確定を更新するAPI
 * @param params 注文情報の入ったパラメータ
 */
export default async function confirmOrderApi(params: OrderConfirmParams) {
  console.log("confirmOrder:", params);

  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/product/publish`;
  const res = await http.post<{messages: string[]}>(url, params);
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  // const res = {status: 200};

  // if (res.status === 200) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "更新が完了しました",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
  return res.data.messages.join('\n');
}
